module.exports = __webpack_public_path__ + "img/bn28.a97b4e79.png";